import _ from 'lodash';
export const name = 'CLASSIFICATION.render';
function renderDefault(h, renderOpts, params) {
    const { row, column } = params;
    const prop = _.get(column, 'property');
    const { _highlightMixin_hlText } = renderOpts;
    const { PN, PATENT_ID } = row || {};
    const cellValue = _.get(row, prop);
    const onMouseenter = (event, content) => {
        window.Bus.$emit('classification:preview:trigger', { PATENT_ID, type: prop, name: content, open: true }, event);
    };
    const onMouseleave = (event, content) => {
        window.Bus.$emit('classification:preview:trigger', { PATENT_ID, type: prop, name: content, open: false }, event);
    };
    const links = _.map(cellValue, (content) => {
        return <span 
        // @ts-ignore
        domProps={{ innerHTML: _highlightMixin_hlText(content) }} data-link-type={prop} data-link-data={content} data-patent-id={PATENT_ID} data-patent-no={PN} 
        // data-bio-uk TODO:  暂不支持
        onMouseenter={(e) => onMouseenter(e, content)} onMouseleave={(e) => onMouseleave(e, content)}/>;
    });
    return [
        <div class="xtable-cell-render" cell-type={prop} cell-render={name}>
            {links}
        </div>,
    ];
}
// 导出模板，例如导出插槽中自定义的内容
function exportMethod(params) {
    const { row, column } = params;
    const result = _.map(row[column.property] || [], item => {
        return item;
    });
    return result.join(',');
}
export default {
    renderDefault,
    exportMethod,
};
